// extracted by mini-css-extract-plugin
module.exports = {"Container":"About_Container__1N2or","Services":"About_Services__eTRWe","Service_Items":"About_Service_Items__3yXpM"};